import { render, staticRenderFns } from "./business-account.vue?vue&type=template&id=03c2f090&scoped=true&"
import script from "./business-account.vue?vue&type=script&lang=js&"
export * from "./business-account.vue?vue&type=script&lang=js&"
import style0 from "./business-account.vue?vue&type=style&index=0&id=03c2f090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2f090",
  null
  
)

export default component.exports